/**
 * Controller: ConflictInterceptor
 */
angular.module('acme.common.controller.conflictInterceptor', [
  'ui.router',
  'ui.bootstrap'
])
.controller('ConflictInterceptorController', [ '$scope', '$rootScope', '$state', '$uibModal', 'errorType', 'errorData', function($scope, $rootScope, $state, $uibModal, errorType, errorData) {

    $scope.conflictInterceptor = {

      modal: false,

      init: function() {
        $scope.$on('AppController::conflict::error', this.onConflictError);
      },

      showModal: function(data) {
        var errorData;

        if (!document.getElementById('conflict-error-modal') && $state.current.name.match(/^application/)) {

          errorData = data.errorData;

          this.modal = $uibModal.open({
            templateUrl: 'common/includes/conflictErrorModal.tpl.html',
            size: 'md',
            controller: 'ConflictInterceptorErrorModalController',
            resolve: {
              errorType: function() {
                return errorType;
              },
              allowCancel: function() {
                return (errorType === 'object_lock_override');
              },
              objectTypeDisplay: function() {
                var r = '';
                if (errorData && errorData.objectType) {
                  switch (errorData.objectType) {
                    case 'EventTemplate':
                      r = 'template';
                      break;
                  }
                }
                return r;
              },
              userInfo: function() {
                var r = '';
                if (errorData && errorData.user) {
                  r = errorData.user;
                }
                return r;
              }
            }

          });

          // Invoked when modal completes with close(params)
          this.modal.result.then(function (result) {
            var self = $scope.conflictInterceptor;

            self.modal = false;
            self.nextState(result);
          },
          //Override the conflict and continue
          function () {
            var self = $scope.conflictInterceptor;
            self.modal = false;
            self.nextState();
          });
        }
      },

      nextState: function(force) {
        var objectId;

        switch (errorType) {
          case 'object_lock_override':
            if (force) {
              if (errorData && errorData.objectId){
                //use rootScope here as the scope of the controller is not same as that of the app
                $rootScope.$broadcast('ConflictInterceptor::update', {id: errorData.objectId, forceEdit: force});
              }
            }
            break;
          case 'object_lock':
          case 'object_lock_system':
          case 'object_lock_no_permission':
          case 'object_lock_save_no_permission':
            break;
          default:
            // Do nothing
            break;
        }

      },

      onConflictError: function(e, data) {
        $scope.conflictInterceptor.showModal(data);
      }

    };

    $scope.conflictInterceptor.init();

}])
  .controller('ConflictInterceptorErrorModalController', ['$scope', '$uibModalInstance', '$sce', 'errorType', 'objectTypeDisplay', 'allowCancel', 'userInfo', function($scope, $uibModalInstance, $sce, errorType, objectTypeDisplay, allowCancel, userInfo) {
    $scope.errors = [];

    $scope.getUserDisplay = function() {
      var r = '';
      if (userInfo) {
        if (userInfo.firstName != null &&
          userInfo.lastName != null &&
          userInfo.firstName !== '' &&
          userInfo.lastName !== '') {
          r = userInfo.firstName + " " + userInfo.lastName;
        } else if (userInfo.email && userInfo.email !== '') {
          r = userInfo.email;
        } else if (userInfo.userName && userInfo.userName !== '') {
          r = userInfo.userName;
        }
      }
      return r;
    };

    $scope.getUserEmail = function() {
      var r = '';
      if (userInfo) {
        if (userInfo.email && userInfo.email !== '') {
          r = userInfo.email;
        }
      }
      return r;
    };

    $scope.strings = {
      object_lock: {
        title: 'Someone else is editing',
        message: $scope.getUserDisplay() ? ('This ' + objectTypeDisplay + ' is currently locked for editing by <strong>' + $scope.getUserDisplay() + '</strong>. Please coordinate and try again later.') : 'This ' + objectTypeDisplay + ' is currently locked for editing. Please coordinate and try again later.',
        auxiliaryMessage: $scope.getUserEmail() ? ('Coordinate via email: <a href="mailto:'+ $scope.getUserEmail() +'">' + $scope.getUserEmail() + '</a>')  : '',
        primaryText: 'Close and try later'
      },
      object_lock_no_permission: {
        title: 'Editing Conflict',
        message: 'You do not have permission to perform this operation.',
        primaryText: 'Close and try later'
      },
      object_lock_save_no_permission: {
        title: 'Editing Conflict',
        message: $scope.getUserDisplay() ? ('This ' + objectTypeDisplay + ' is currently locked for editing by <strong>' + $scope.getUserDisplay() + '</strong>. Any changes you have made will not be saved. Take note of your edits and coordinate with ' + $scope.getUserDisplay()) : 'This ' + objectTypeDisplay + ' is currently locked for editing. Please coordinate and try again later.',
        auxiliaryMessage: $scope.getUserEmail() ? ('Coordinate via email: <a href="mailto:'+ $scope.getUserEmail() +'">' + $scope.getUserEmail() + '</a>')  : '',
        primaryText: 'Close and review edits'
      },
      object_lock_override: {
        title: 'Someone else is editing',
        message: $scope.getUserDisplay() ? ('This ' + objectTypeDisplay + ' is currently locked for editing by <strong>' + $scope.getUserDisplay() + '</strong>. Please coordinate and try again later.') : 'This ' + objectTypeDisplay + ' is currently locked for editing. Please coordinate and try again later.',
        auxiliaryMessage: $scope.getUserEmail() ? ('Coordinate via email: <a href="mailto:'+ $scope.getUserEmail() +'">' + $scope.getUserEmail() + '</a>')  : '',
        primaryText: 'Close and try later',
        secondaryText: 'Take control of editing'
      },
      object_lock_system: {
        title: 'Publish in progress',
        message: 'This action currently cannot be performed as it is being used by the system. Please try again later.',
        primaryText: 'Close and try later'
      }
    };

    $scope.model = {
      primaryText: '',
      secondaryText: ''
    };

    $scope.init = function() {
      var message = '',
          auxiliaryMessage = '';

      $scope.model.primaryText = '';

      $scope.allowCancel = allowCancel;

      switch (errorType) {
        case 'object_lock':
          $scope.model.title = $scope.strings.object_lock.title;
          message = $scope.strings.object_lock.message;
          auxiliaryMessage = $scope.strings.object_lock.auxiliaryMessage;
          $scope.model.primaryText = $scope.strings.object_lock.primaryText;
          break;
        case 'object_lock_override':
          $scope.model.title = $scope.strings.object_lock_override.title;
          message = $scope.strings.object_lock_override.message;
          auxiliaryMessage = $scope.strings.object_lock_override.auxiliaryMessage;
          $scope.model.primaryText = $scope.strings.object_lock_override.primaryText;
          $scope.model.secondaryText = $scope.strings.object_lock_override.secondaryText;
          break;
        case 'object_lock_system':
          $scope.model.title = $scope.strings.object_lock_system.title;
          message = $scope.strings.object_lock_system.message;
          auxiliaryMessage = $scope.strings.object_lock_system.auxiliaryMessage;
          $scope.model.primaryText = $scope.strings.object_lock_system.primaryText;
          break;
        case 'object_lock_no_permission':
          $scope.model.title = $scope.strings.object_lock_no_permission.title;
          message = $scope.strings.object_lock_no_permission.message;
          auxiliaryMessage = $scope.strings.object_lock_no_permission.auxiliaryMessage;
          $scope.model.primaryText = $scope.strings.object_lock_no_permission.primaryText;
          break;
        case 'object_lock_save_no_permission':
          $scope.model.title = $scope.strings.object_lock_save_no_permission.title;
          message = $scope.strings.object_lock_save_no_permission.message;
          auxiliaryMessage = $scope.strings.object_lock_save_no_permission.auxiliaryMessage;
          $scope.model.primaryText = $scope.strings.object_lock_save_no_permission.primaryText;
          break;
        default:
          $scope.model.title = 'Conflict Error';
          message = 'Error: ' + errorType;
          $scope.model.primaryText = 'Close';
      }

      $scope.model.message = $sce.trustAsHtml(message);
      $scope.model.auxiliaryMessage = $sce.trustAsHtml(auxiliaryMessage);
    };

    $scope.hasErrors = function() {
      return ($scope.errors.length > 0);
    };

    $scope.done = function(ignoreConflictAndContinue) {
      $scope.success(ignoreConflictAndContinue);
    };

    $scope.cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.success = function(ignoreConflictAndContinue) {
      $uibModalInstance.close(ignoreConflictAndContinue);
    };

    $scope.init();

  }]);